module.exports = __webpack_public_path__ + "static/media/floodinsurencedoma.db19339e.svg";